/*
  Vá lỗi khởi tạo của widget Judge.me, cộng thêm tooltip cho dấu tích ở avatar.

  Triệu chứng gốc: ở khổ desktop, script của app đo bề rộng widget rồi gán class
  cỡ (--small / --medium / không có). Trong lúc đo nó ẩn nút "Write a review"
  bằng inline style rồi mới hiện lại. Khi kết thúc mà không gán class cỡ nào
  thì bước hiện lại đôi khi không chạy — nút biến mất, và cùng đoạn khởi tạo đó
  cũng không gắn được thao tác mở form.

  Đo ở 390/600/749/750/900/1280: mất nút ở 749 và 1280, còn ở các khổ khác —
  tức là tranh chấp thời điểm, không theo khổ màn hình.

  Bản vá làm năm việc, đều tự vô hiệu khi app chạy đúng:
    1. Gỡ inline display:none trên nút, nếu không có form nào đang mở.
    2. Khi bấm nút mà form vẫn ẩn thì mở giúp.
    3. Gắn tooltip cho dấu tích "đã mua hàng" ở góc avatar.
    4. Tách "5.00 out of 5" thành số và đơn vị để CSS cho hai cỡ chữ khác nhau.
    5. Đặt chữ cái đầu của tên người viết vào data-initial cho avatar.

  Việc 4 và 5 là phần giao diện, không phải vá lỗi — nhưng cả hai đều là thứ CSS
  không tự làm được vì markup do app dựng, nên để chung một chỗ với các thao tác
  DOM khác trên widget thay vì thêm một file nữa.

  KHÔNG đụng tới việc gửi review — phần đó vẫn do app xử lý.
*/
(function () {
  var BTN = '.jdgm-write-rev-link';
  var FORM = '.jdgm-form-wrapper';

  function isHidden(el) {
    return !el || getComputedStyle(el).display === 'none';
  }

  function hasOpenForm(root) {
    var forms = root.querySelectorAll(FORM);
    for (var i = 0; i < forms.length; i++) {
      if (!isHidden(forms[i])) return true;
    }
    return false;
  }

  function restoreWriteButton() {
    document.querySelectorAll(BTN).forEach(function (button) {
      var widget = button.closest('.jdgm-widget') || document;

      // App ẩn nút lúc form đang mở là hợp lệ — chỉ can thiệp khi form đóng.
      if (hasOpenForm(widget)) return;

      if (button.style.display === 'none') button.style.display = '';
    });
  }

  /*
    Chữ trong nhãn "Verified" KHÔNG nằm trong DOM — app vẽ nó bằng CSS
    ::before content, nên textContent trả về chuỗi rỗng. Phải đọc qua
    getComputedStyle rồi bóc cặp nháy bao quanh.
  */
  function readLabel(el) {
    var value = '';
    try {
      value = getComputedStyle(el, '::before').content || '';
    } catch (e) {
      return '';
    }
    if (!value || value === 'none' || value === 'normal') {
      return (el.textContent || '').trim();
    }
    return value.replace(/^["']|["']$/g, '').trim();
  }

  /*
    Dấu tích xanh ở góc avatar không tự nói được nó nghĩa là gì. Gắn tooltip
    bằng thuộc tính title, nội dung lấy từ chính nhãn của app nên đi theo ngôn
    ngữ đang bật, không phải chuỗi tiếng Anh gõ cứng trong theme.

    Vì chữ nằm trong pseudo-element mà trình đọc màn hình đọc rất thất thường,
    title ở đây còn gánh luôn vai trò nhãn trợ năng cho dấu tích.
  */
  function addVerifiedTooltips() {
    document.querySelectorAll('.jdgm-rev').forEach(function (review) {
      var icon = review.querySelector('.jdgm-rev__icon');
      var badge = review.querySelector('.jdgm-rev__buyer-badge');
      if (!icon || !badge || icon.getAttribute('title')) return;

      var label = readLabel(badge);
      if (label) icon.setAttribute('title', label);
    });
  }

  /*
    Tách "5.00 out of 5" thành hai mẩu để CSS cho điểm cỡ lớn, đơn vị cỡ nhỏ.

    App đổ cả câu vào MỘT text node, mà CSS thì không cắt được chữ giữa một text
    node — không có cách nào làm bằng stylesheet. Chỉ bọc thêm hai <span>, không
    đổi chữ, nên đọc màn hình vẫn nghe nguyên câu "5.00 out of 5".

    Khớp cả dạng "5.00 out of 5" lẫn "4,62 sur 5" (dấu phẩy thập phân, chữ khác
    ngôn ngữ): lấy cụm số ở ĐẦU chuỗi, phần còn lại là đơn vị.
  */
  function splitAverageScore() {
    document.querySelectorAll('.jdgm-rev-widg__summary-average').forEach(function (el) {
      if (el.querySelector('.cl-jdgm-score')) return;

      var text = (el.textContent || '').trim();
      var match = text.match(/^([\d.,]+)\s*(.*)$/);
      if (!match) return;

      var score = document.createElement('span');
      score.className = 'cl-jdgm-score';
      score.textContent = match[1];

      el.textContent = '';
      el.appendChild(score);

      if (match[2]) {
        var unit = document.createElement('span');
        unit.className = 'cl-jdgm-score-unit';
        unit.textContent = match[2];
        el.appendChild(unit);
      }
    });
  }

  /*
    Chữ cái đầu của tên người viết, đặt vào data-initial để CSS vẽ trong avatar.

    Mặc định mọi avatar là cùng một hình người xám, nên năm review nhìn như của
    cùng một người. Không viết chữ thẳng vào DOM mà đi qua thuộc tính: app dựng
    lại thẻ review sau mỗi lần sang trang / đổi sắp xếp, thêm node vào là nó xoá
    mất, còn ::before của CSS thì vẽ lại theo thuộc tính bao nhiêu lần cũng được.
  */
  function addAuthorInitials() {
    document.querySelectorAll('.jdgm-rev').forEach(function (review) {
      var icon = review.querySelector('.jdgm-rev__icon');
      var author = review.querySelector('.jdgm-rev__author');
      if (!icon || !author || icon.getAttribute('data-initial')) return;

      var name = (author.textContent || '').trim();
      if (!name) return;

      icon.setAttribute('data-initial', name.charAt(0).toUpperCase());
    });
  }

  /*
    moveUgcGrid() (bê khối reviews_grid_widget vào cột phải) đã bỏ 16/10/2026: khối đó trả
    ảnh của CẢ STORE, nay dải "Reviews with Images" do judgeme-tabs.js dựng từ chính review
    của sản phẩm, và app block đã gỡ khỏi templates/product.json.
  */

  /*
    Ẩn review của SẢN PHẨM KHÁC.

    Judge.me đang gộp nhóm sản phẩm, nên một món chưa ai đánh giá vẫn hiện đầy
    review — của món khác. Đo ngày 13/08/2026 trên trang áo "Father's day
    Personalized Shirt Best Dog Dad Ever": API trả `total_count: 0` cho chính
    product_id của nó, mà widget vẫn dựng 5 thẻ, thuộc ba sản phẩm khác, và thẻ
    review KHÔNG hề ghi tên sản phẩm gốc (`.jdgm-row-product` rỗng). Khách đọc
    tưởng là đánh giá cho món đang xem.

    Mỗi thẻ review có sẵn `data-product-url`; đối chiếu với đường dẫn trang là
    biết ngay. Cái nào lạc thì ẩn.

    Không còn cái nào của chính sản phẩm thì gắn dấu lên widget để CSS giấu nốt
    phần điểm số, biểu đồ và phân trang — mấy con số đó cũng là của nhóm, giữ
    lại thì vẫn là nói sai. Nút "Write a review" vẫn còn, kèm một dòng mời viết.

    Gốc rễ nằm ở Judge.me (Settings → Product grouping), đây chỉ là chặn phần
    hiển thị sai cho tới khi dọn xong dữ liệu.
  */
  function hideForeignReviews() {
    var widget = document.querySelector('.jdgm-review-widget');
    var host = document.querySelector('.jdgm-rev-widg__reviews');
    if (!widget || !host) return;

    /*
      Nhóm sản phẩm (snippets/judgeme-groups.liquid + judgeme-tabs.js) CỐ Ý kéo
      review của sản phẩm anh em về và gắn nhãn "Review for: <tên>". Hàm này thì
      sinh ra để ẩn đúng loại review đó. Hai chính sách ngược nhau cho cùng một
      vấn đề: review lạc không nhãn thì phải giấu, review lạc CÓ nhãn thì được
      phép hiện.

      Nên chỉ lùi khi thanh tab đã THỰC SỰ dựng xong danh sách (`clTabsReady`),
      chứ không phải chỉ vì trang có khai nhóm. Lùi sớm là review lạc do chính
      Judge.me trả về — thứ chưa ai gắn nhãn, và thường không nằm trong nhóm
      khai báo — lọt ra trong lúc chờ API.

      Bug 21/08/2026: thiếu câu này thì dòng "No reviews for this product yet"
      hiện ngay trên 18 review đang bày ra. Cùng lúc, việc review vẫn hiện được
      chỉ là ăn may — luật `.cl-jdgm-list .jdgm-rev[hidden]{display:block
      !important}` trong judgeme-custom.css vô tình đè luôn `style.display` inline
      mà hàm này đặt. Có guard rồi thì không còn dựa vào tác dụng phụ đó nữa.
    */
    if (host.dataset.clTabsReady === '1') return;

    var reviews = [].slice.call(host.querySelectorAll('.jdgm-rev'));
    if (!reviews.length) return;

    var here = window.location.pathname;
    var own = 0;
    var foreign = [];

    reviews.forEach(function (review) {
      var url = review.getAttribute('data-product-url');
      /* Không có thuộc tính thì không kết luận được — coi như của chính nó,
         thà giữ nhầm còn hơn giấu nhầm review thật. */
      if (!url || url === here) own++;
      else foreign.push(review);
    });

    if (!foreign.length) return;

    foreign.forEach(function (review) {
      review.hidden = true;
      review.style.display = 'none';
    });

    if (own > 0) return;

    widget.setAttribute('data-cl-no-own-reviews', '');

    /*
      Dòng mời viết đặt TRONG thẻ tóm tắt, đúng chỗ cụm điểm số vừa bị ẩn — để
      ngoài thì nó trôi lửng lơ dưới thẻ, nhìn như mẩu chữ rơi rớt của section
      khác. Không có thẻ tóm tắt thì mới rơi về danh sách review.
    */
    var header = document.querySelector('.jdgm-rev-widg__header') || host;
    if (!header.querySelector('.cl-jdgm-none')) {
      var note = document.createElement('p');
      note.className = 'cl-jdgm-none';
      note.textContent = 'No reviews for this product yet — be the first to share yours.';
      header.appendChild(note);
    }
  }

  function applyPatches() {
    restoreWriteButton();
    addVerifiedTooltips();
    splitAverageScore();
    addAuthorInitials();
    hideForeignReviews();
  }

  // Chạy vài nhịp trong lúc widget còn đang khởi tạo, rồi dừng hẳn.
  var ticks = 0;
  var timer = setInterval(function () {
    applyPatches();
    if (++ticks >= 10) clearInterval(timer);
  }, 400);

  /*
    Lọc, sắp xếp, sang trang đều thay mới danh sách review — thẻ vừa nạp chưa có
    tooltip lẫn chữ cái avatar. Bắt mọi cú bấm trong widget rồi gắn lại, chờ đủ
    lâu cho lượt gọi API của app trả về.
  */
  function decorateReviews() {
    addVerifiedTooltips();
    addAuthorInitials();
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest || !e.target.closest('.jdgm-widget')) return;
      setTimeout(decorateReviews, 600);
      setTimeout(decorateReviews, 1800);
      setTimeout(decorateReviews, 3500);
    },
    true
  );

  /*
    Widget nạp lười, có thể xuất hiện sau khi vòng lặp trên đã dừng.

    Gộp nhiều mutation vào một nhịp vẽ — 19/08/2026. Trước đây MỌI mutation đều
    gọi thẳng applyPatches(), mà hàm đó chạy 6 lượt querySelectorAll toàn trang
    kèm getComputedStyle() (ép tính lại style đồng bộ). Trên trang product có cả
    Vue của Customily lẫn Vue của Judge.me vẽ lại liên tục, thành hàng nghìn lượt
    trong 30 giây đầu. Cùng cơ chế queued + rAF mà judgeme-tabs.js đang dùng.
  */
  if (window.MutationObserver) {
    var queued = false;
      /* setTimeout chứ không phải requestAnimationFrame — sửa 19/08/2026.
         rAF BỊ TREO ở tab nền, mà khách rất hay mở sản phẩm sang tab nền rồi mới xem.
         Lúc đó setTimeout(30s) ngắt observer vẫn chạy đúng giờ trong khi callback rAF
         chưa hề chạy lần nào → bản vá không bao giờ được áp. setTimeout chỉ bị giãn
         nhịp ở tab nền chứ không treo. 50ms đủ gộp các đợt mutation của Vue. */
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        applyPatches();
      }, 50);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    /* 30s chứ không phải 15s: cả widget review lẫn khối ảnh đều tải lười, khách
       đọc phần mô tả một lúc rồi mới cuộn xuống là quá 15 giây — lúc đó không
       còn ai theo dõi để trang trí lại. */
    setTimeout(function () {
      observer.disconnect();
    }, 30000);
  }

  /*
    Bắt ở pha capture để chạy trước handler của app; không chặn sự kiện, nên
    nếu handler của app vẫn sống thì nó chạy bình thường ngay sau đó.
  */
  document.addEventListener(
    'click',
    function (e) {
      var button = e.target.closest && e.target.closest(BTN);
      if (!button) return;

      var widget = button.closest('.jdgm-widget') || document;

      // Cho app cơ hội tự mở trước; chỉ nhảy vào khi nó không làm gì.
      setTimeout(function () {
        var form = widget.querySelector(FORM);
        if (form && isHidden(form)) {
          form.style.display = 'block';
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 250);
    },
    true
  );
})();
